import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

const returnSteps = [
  {
    number: "01",
    title: "Start your request",
    text: "Contact customer care with your order number and the item you would like to return.",
  },
  {
    number: "02",
    title: "Pack your item",
    text: "Use the original packaging where possible and include every tag, accessory, and garment bag.",
  },
  {
    number: "03",
    title: "Send it back",
    text: "Follow the return instructions in our reply and keep your carrier receipt until processing is complete.",
  },
  {
    number: "04",
    title: "Receive your refund",
    text: "Approved refunds return to the original payment method within 5–10 business days of inspection.",
  },
];

function Returns() {
  return (
    <main className="returns-page">
      <header className="returns-page__header">
        <p className="returns-page__eyebrow">Help &amp; information</p>
        <h1>Returns &amp; exchanges</h1>
        <p>
          We want every {siteConfig.brandName} piece to feel right. Eligible
          items may be returned within {siteConfig.returnWindowDays} days of
          delivery.
        </p>
      </header>

      <section className="returns-page__steps" aria-labelledby="return-steps-title">
        <h2 id="return-steps-title">How to make a return</h2>
        <div className="returns-page__step-grid">
          {returnSteps.map((step) => (
            <article key={step.number}>
              <span>{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </article>
          ))}
        </div>
      </section>

      <div className="returns-page__details">
        <section aria-labelledby="return-condition-title">
          <p className="returns-page__eyebrow">Return condition</p>
          <h2 id="return-condition-title">Unworn, unwashed, and ready for its next home.</h2>
          <p>
            Items must be in original condition with all tags attached. Please
            try garments on carefully and keep them away from fragrance, smoke,
            pet hair, and anything that may mark the fabric.
          </p>
          <p>
            Original shipping charges are not refundable. Return postage is
            deducted from the refund unless the item arrived damaged or we sent
            something different from your order.
          </p>
        </section>
        <section aria-labelledby="return-exclusions-title">
          <p className="returns-page__eyebrow">Please note</p>
          <h2 id="return-exclusions-title">Items we cannot accept</h2>
          <ul>
            <li>Final-sale items and gift cards</li>
            <li>Worn, washed, altered, or damaged merchandise</li>
            <li>Items without their original tags or packaging</li>
            <li>
              Returns requested more than {siteConfig.returnWindowDays} days
              after delivery
            </li>
          </ul>
        </section>
      </div>

      <section className="returns-page__exchange" aria-labelledby="exchange-title">
        <p className="returns-page__eyebrow">A different size or color?</p>
        <h2 id="exchange-title">The quickest exchange is a new order.</h2>
        <p>
          Place a new order for the item you want, then return the original item
          separately. This prevents limited stock from selling out while your
          return is in transit.
        </p>
        <div className="returns-page__actions">
          <Link to="/contact" className="returns-page__button returns-page__button--dark">
            Start a return
          </Link>
          <Link to="/shop" className="returns-page__button">
            Continue shopping
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Returns;
